import { render, staticRenderFns } from "./CustomerShow.vue?vue&type=template&id=4969ef3a&"
import script from "./CustomerShow.vue?vue&type=script&lang=js&"
export * from "./CustomerShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports